import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import './SurveyModal.css';

const SurveyRunningTotal = ({ questionId }) => {
  const [question, setQuestion] = useState(null);
  const [totals,   setTotals]   = useState({});
  const [loading,  setLoading]  = useState(true);
  const [total,    setTotal]    = useState(0);

  useEffect(() => {
    if (!questionId) return;
    const load = async () => {
      const [{ data: q }, { data: t }] = await Promise.all([
        supabase
          .from('survey_questions')
          .select('question_text, options')
          .eq('id', questionId)
          .single(),
        supabase.rpc('get_survey_totals', { p_question_id: questionId }),
      ]);
      setQuestion(q);
      const m = {};
      let sum = 0;
      t?.forEach(row => {
        m[row.answer_option_id] = Number(row.response_count);
        sum += Number(row.response_count);
      });
      setTotals(m);
      setTotal(sum);
      setLoading(false);
    };
    load();
  }, [questionId]);

  if (loading || !question) return null;

  return (
    <div className="survey-running-total">
      <div className="survey-running-total-header">
        <span className="survey-running-total-eyebrow">Community Poll</span>
        <span className="survey-running-total-live">● Live results</span>
      </div>
      <div className="survey-running-total-question">{question.question_text}</div>
      <div className="survey-running-total-bars">
        {question.options.map(opt => {
          const count = totals[opt.id] || 0;
          const pct = total > 0 ? Math.round((count / total) * 100) : 0;
          return (
            <div key={opt.id} className="survey-result-row">
              <div className="survey-result-label">{opt.label}</div>
              <div className="survey-result-bar-wrap">
                <div className="survey-result-bar" style={{ width: `${pct}%` }} />
              </div>
              <div className="survey-result-pct">
                {pct}% <span className="survey-result-count">({count})</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className="survey-result-total">
        {total} total {total === 1 ? 'response' : 'responses'}
      </div>
    </div>
  );
};

export default SurveyRunningTotal;
